var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHepTextFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99967 14.6663C11.6816 14.6663 14.6663 11.6816 14.6663 7.99967C14.6663 4.31778 11.6816 1.33301 7.99967 1.33301C4.31778 1.33301 1.33301 4.31778 1.33301 7.99967C1.33301 11.6816 4.31778 14.6663 7.99967 14.6663Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.66683 5.33301C7.66683 5.05687 7.89069 4.83301 8.16683 4.83301H8.17283C8.44897 4.83301 8.67283 5.05687 8.67283 5.33301C8.67283 5.60915 8.44897 5.83301 8.17283 5.83301H8.16683C7.89069 5.83301 7.66683 5.60915 7.66683 5.33301ZM8.09935 6.84968C8.24553 6.86933 8.43234 6.91987 8.58955 7.07708C8.74674 7.23427 8.79732 7.42103 8.81699 7.56729C8.83378 7.69212 8.83372 7.83999 8.83366 7.97673C8.83366 7.98442 8.83366 7.99208 8.83366 7.99969V10.6664C8.83366 10.9425 8.6098 11.1664 8.33366 11.1664C8.05752 11.1664 7.83366 10.9425 7.83366 10.6664V7.99969C7.83366 7.93364 7.83364 7.8801 7.83289 7.8338C7.78659 7.83305 7.73304 7.83303 7.66699 7.83303C7.39085 7.83303 7.16699 7.60917 7.16699 7.33303C7.16699 7.05689 7.39085 6.83303 7.66699 6.83303C7.67461 6.83303 7.68226 6.83303 7.68995 6.83302C7.8267 6.83297 7.97455 6.83291 8.09935 6.84968Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHepTextFill);
export default __webpack_public_path__ + "static/media/iconHepTextFill.4991155611c62756c6bb25537f091aaf.svg";
export { ForwardRef as ReactComponent };